var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM7.77254 22.5H11.1933V11.4838H7.77254V22.5ZM7.5 7.98115C7.5 9.07504 8.38724 9.98108 9.4811 9.98108C10.5746 9.98108 11.4622 9.07504 11.4622 7.98115C11.4622 7.45572 11.2535 6.9518 10.882 6.58027C10.5104 6.20873 10.0065 6 9.4811 6C8.95568 6 8.45178 6.20873 8.08025 6.58027C7.70872 6.9518 7.5 7.45572 7.5 7.98115ZM20.5829 22.5H23.9963H24V16.4486C24 13.4874 23.3636 11.2076 19.9015 11.2076C18.2372 11.2076 17.1216 12.121 16.6649 12.9865H16.617V11.4838H13.3361V22.5H16.7533V17.0453C16.7533 15.6089 17.0258 14.2204 18.8043 14.2204C20.5571 14.2204 20.5829 15.8593 20.5829 17.1374V22.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.133f0bbf9f4e396a1867964d0ac52442.svg";
export { ForwardRef as ReactComponent };